import * as React from 'react';

interface Props {
  style: any;
  width: number;
  onChange: (value: number) => void;
  onChangeStart?: () => void;
  onChangeEnd?: () => void;
}

export default class extends React.Component<Props> {
  componentWillUnmount() {
    this.didRelease();
  }
  didClick = () => {
    window.addEventListener('mousemove', this.didDrag);
    window.addEventListener('mouseup', this.didRelease);
    if (this.props.onChangeStart) {
      this.props.onChangeStart();
    }
  };
  didDrag = (e: MouseEvent) => {
    const position = Math.max(0, Math.min(1, e.clientX / this.props.width));
    this.props.onChange(position);
  };
  didRelease = () => {
    window.removeEventListener('mousemove', this.didDrag);
    window.removeEventListener('mouseup', this.didRelease);
    if (this.props.onChangeEnd) {
      this.props.onChangeEnd();
    }
  };
  render() {
    return (
      <div
        onMouseDown={this.didClick}
        className="draggable-point"
        style={this.props.style}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/motion/DraggablePoint.tsx